export const stats = [
  { value: '5', label: 'Volumi Completi' },
  { value: '600+', label: 'Pagine di Risorse' },
  { value: '300+', label: 'Unità Didattiche' },
  { value: '100%', label: "Pronto per l'Aula" },
]

export const beforeItems = [
  'Passare le domeniche a risolvere problemi complessi e creare schede da zero.',
  'Cercare simulazioni o esercizi online che non si adattano mai al livello della tua classe.',
  'Dover creare da zero test di verifica e passare notti intere a scrivere le soluzioni.',
  'Sentirti frustrato perché la burocrazia e la preparazione ti tolgono il piacere di spiegare.',
]

export const afterItems = [
  'Un intero anno mappato e organizzato per ogni classe del liceo.',
  'Lezioni visuali e schemi pronti per la stampa o per essere proiettati sulla LIM.',
  'Esercizi svolti passo dopo passo per mostrare il metodo corretto in aula.',
  'Verifiche integrate e chiavi di correzione incluse per risparmiare settimane di lavoro.',
]

export const recognizeItems = [
  'Non hai più tempo per preparare lezioni che rendano semplici concetti complessi.',
  'Vedi gli studenti bloccarsi davanti alle formule perché manca un approccio visuale.',
  'Gestire il programma ministeriale e la preparazione alla Maturità ti sembra una corsa contro il tempo.',
  'Cerchi materiale di alta qualità che sia allo stesso tempo rigoroso e facile da spiegare.',
]

export type Volume = {
  number: number
  title: string
  text: string
}

export const volumes: Volume[] = [
  {
    number: 1,
    title: 'Fondamenti, Misura e Statica',
    text: "Dal Sistema Internazionale all'equilibrio dei corpi. La base solida per ogni studente.",
  },
  {
    number: 2,
    title: 'Cinematica e Dinamica',
    text: 'Il moto e le leggi di Newton spiegati con schemi visuali e problemi guidati.',
  },
  {
    number: 3,
    title: 'Termodinamica e Fluidi',
    text: 'Leggi dei gas, calore e idrostatica. Concetti pronti da proiettare e risolvere.',
  },
  {
    number: 4,
    title: 'Onde ed Ottica',
    text: 'Fenomeni ondulatori e ottica geometrica: tutto il quarto anno risolto.',
  },
  {
    number: 5,
    title: 'Elettromagnetismo e Fisica Moderna',
    text: "Dalle cariche elettriche alla relatività. Preparazione completa per l'Esame di Stato.",
  },
]

export const bonuses = [
  {
    title: 'Fisica Inclusiva — Mappe e Schede per BES & DSA',
    text: 'Risorse speciali per l’apprendimento facilitato: mappe concettuali e schede semplificate per non lasciare indietro nessuno.',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/74f3f909-1745-4c1c-bb60-793d0ce35ed4.jpg',
  },
  {
    title: 'Il Formulario Visuale Definitivo',
    text: 'Tutte le formule dei 5 anni in un solo posto: uno strumento di consultazione rapida, grafico e ad alto impatto.',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/cbba739c-2a5b-4af9-aad1-b945c96b29dc.jpg',
  },
  {
    title: 'Laboratorio di Fisica "Fai-da-Te"',
    text: '20 esperimenti pratici con materiali di recupero: schede di laboratorio pronte all’uso per rendere la fisica tangibile.',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/b46d969b-df91-48b3-81f2-896d282c6bc9.jpg',
  },
  {
    title: "Banca Dati Verifiche — Test & Problemi Pronti all'Uso",
    text: 'Oltre 100 quesiti organizzati per livello e argomento: una risorsa indispensabile per valutare in un clic.',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/75c0b889-2b2e-4713-aa0f-8d24ec6dc0f7.jpg',
  },
  {
    title: 'Obiettivo Maturità — La Guida Definitiva alla Seconda Prova',
    text: 'Strategie, problemi svolti e simulazioni per l’Esame di Stato: tutto ciò che serve per arrivare preparati.',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/eb6a0edc-8893-439a-b1d8-86a821a2c851.jpg',
  },
]

export const offerRows = [
  { label: 'Pack FISICA PRONTA (5 Volumi)', value: '€197' },
  { label: '5 Bonus Strategici', value: '€185' },
]

export const testimonials = [
  {
    quote:
      "È il materiale che avrei voluto avere all'inizio della carriera. Gli schemi per la LIM sono fantastici e le verifiche già pronte mi hanno salvato i weekend.",
    name: 'Alessandro B.',
    role: 'Docente di Fisica e Matematica',
  },
  {
    quote:
      'Finalmente un supporto visuale che rende la fisica comprensibile anche a chi odia le formule. Consigliatissimo per chi vuole qualità e ordine.',
    name: 'Chiara V.',
    role: 'Insegnante di Liceo',
  },
]

export const faqs = [
  {
    q: 'In che formato sono i materiali?',
    a: 'PDF ad alta risoluzione pronti per stampa o proiezione.',
  },
  {
    q: 'Come ricevo il materiale?',
    a: 'Immediatamente via email dopo il pagamento.',
  },
  {
    q: 'Posso usarlo su tablet?',
    a: 'Sì, è perfetto per tablet, PC e smartphone.',
  },
]

export const heroGuarantees = [
  'Download digitale istantaneo',
  'PDF pronti per la stampa',
  'Pagamento unico',
]

export const footerLinks = ['Termini e Condizioni', 'Privacy Policy', 'Contatti']
